import {t} from '../../../common/getTranslations';
import {formatWithCommas} from '../../../common/shared/utils/formatWithCommas';
import {twMerge} from '../../../common/twMerge';
import {TicketKind} from '../../../graphql/generated/types';
import {theme} from '../../../theme';
import {Separator} from '../../atoms/Separator/Separator';
import {StaticImage} from '../../atoms/StaticImage/StaticImage';
import {StaticImageType} from '../../atoms/StaticImage/StaticImageType.enum';
import {Text} from '../../atoms/Text/Text';
import {VerticalListWithDivider} from '../../molecules/VerticalListWithDivider/VerticalListWithDivider';
import {BuyTicketChargeAreaProps} from './BuyTicketChargeAreaProps.interface';

export function BuyTicketChargeArea({
  ticketKind,
  notReadCount,
  possessionTicketCount,
  children,
  shouldShowLastDivider,
  className,
  ...props
}: BuyTicketChargeAreaProps) {
  return (
    <div
      {...props}
      className={twMerge('bg-theme-bg-base py-24pxr px-15pxr', className)}
    >
      <div className="flex justify-between">
        <div className="flex flex-col">
          <Text className="font-large3-bold text-theme-solid-100">
            {ticketKind === TicketKind.Rent
              ? t('ticket_purchase_rental')
              : t('ticket_purchase_possession')}
          </Text>
          <Text className="font-small2 mt-4pxr flex items-center text-theme-solid-60">
            {t(
              ticketKind === TicketKind.Rent
                ? 'ticket_purchase_ep_unread'
                : 'ticket_purchase_ep_uncollected',
              {
                values: {
                  value:
                    !!notReadCount || notReadCount === 0
                      ? formatWithCommas(notReadCount)
                      : '-',
                },
                options: {
                  props: {
                    className: 'ml-2pxr',
                  },
                },
              }
            )}
            <Separator className="mx-6pxr h-12pxr bg-theme-transparent-20" />
            {t(
              ticketKind === TicketKind.Rent
                ? 'ticket_purchase_ticket_balance_rental'
                : 'ticket_purchase_ticket_balance_possession',
              {
                values: {
                  value:
                    possessionTicketCount === undefined
                      ? '-'
                      : formatWithCommas(possessionTicketCount),
                },
                options: {
                  props: {
                    className: 'ml-2pxr',
                  },
                },
              }
            )}
          </Text>
        </div>
        {ticketKind === TicketKind.Rent && (
          <div className="flex items-center justify-center">
            <StaticImage
              imageType={StaticImageType.Coupon72h}
              className="h-42pxr w-42pxr"
            />
          </div>
        )}
      </div>
      <VerticalListWithDivider
        dividerColor={theme.colors['theme-transparent-10']}
        shouldShowLastDivider={shouldShowLastDivider}
      >
        {children}
      </VerticalListWithDivider>
      {ticketKind === TicketKind.Rent && (
        <div className="mt-12pxr mb-4pxr">
          {/* TODO: @Root-huh bg-[#7a7a7a] - 매칭되는 디자인 토큰 없음 */}
          <ul className="font-small2 text-theme-solid-60 [&>li]:pl-8pxr [&>li]:-indent-8pxr [&>li]:before:mr-6pxr [&>li]:before:mt-7pxr [&>li]:before:inline-block [&>li]:before:h-2pxr [&>li]:before:w-2pxr [&>li]:before:rounded-[50%] [&>li]:before:bg-[#7a7a7a] [&>li]:before:align-top">
            <li>
              {t('ticket_purchase_rental_info_1', {
                values: {
                  value: t('common_period_hour', {values: {value: 72}}),
                },
              })}
            </li>
            <li className="mt-8pxr">
              {t('ticket_purchase_rental_info_2', {
                values: {
                  value: t('common_period_hour', {values: {value: 72}}),
                },
              })}
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
